module.exports = __webpack_public_path__ + "static/pt-serif-v12-latin-700-49182afbed72d10e31e144845c200cdc.woff2";